<template>
  <v-chip
    small
    label
    :color="dataView.color"
    text-color="white"
  >
    {{ dataView.title }}
  </v-chip>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    dict: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dataView() {
      return Object.values(this.dict).find(({ value }) => value === this.value);
    },
  },
};
</script>